// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrganizationVerticalDTO
 */
export interface OrganizationVerticalDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationVerticalDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationVerticalDTO
     */
    type: OrganizationVerticalDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationVerticalDTO
     */
    name: OrganizationVerticalDTONameEnum;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationVerticalDTO
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationVerticalDTO
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum OrganizationVerticalDTOTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY'
}
/**
    * @export
    * @enum {string}
    */
export enum OrganizationVerticalDTONameEnum {
    INDEPENDENTSINGLE = 'INDEPENDENT_SINGLE',
    BTR = 'BTR',
    INDEPENDENTMULTI = 'INDEPENDENT_MULTI',
    FRANCHISE = 'FRANCHISE',
    CORPORATE = 'CORPORATE',
    PRIVATELANDLORD = 'PRIVATE_LANDLORD',
    STUDENT = 'STUDENT',
    HMO = 'HMO',
    PBSA = 'PBSA'
}



